import { useApi } from './useApi';
import { fetchDashboardAlerts, fetchSupplierAlertCount } from '@/lib/api';
import { deriveAlertCounts, type AlertCounts } from './alertCounts';

export type { AlertCounts } from './alertCounts';

/** SPEC-527 fix loop 4: a count is null ("not known") when its read failed — never 0.
 *  `loading` is true until the first alert read settles (a 0 then is not a claim). */
export function useAlertCounts(): AlertCounts & { loading: boolean } {
  const alerts = useApi(fetchDashboardAlerts);
  const supplierAlert = useApi(fetchSupplierAlertCount);
  return {
    ...deriveAlertCounts(alerts.data, alerts.error, supplierAlert.data, supplierAlert.error),
    loading: alerts.loading,
  };
}
